module.exports = ".modal-backdrop.show {\n  opacity: 0; }\n\n.loader-overlay {\n  position: absolute;\n  width: 100%;\n  z-index: 500000;\n  top: 0; }\n\n.loader {\n  height: auto;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.scss
// module id = ./src/app/loader/loader.component.scss
// module chunks = main